import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://example.invalid';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'missing-anon-key';

if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
  // Do not throw at import time, otherwise the whole SPA can fail before React mounts.
  console.error('Missing Supabase environment variables. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types for TypeScript
export interface Database {
  public: {
    Tables: {
      allowlisted_wallets: {
        Row: {
          wallet_address: string;
          role: string;
          active: boolean;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          wallet_address: string;
          role?: string;
          active?: boolean;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          wallet_address?: string;
          role?: string;
          active?: boolean;
          created_at?: string;
          updated_at?: string;
        };
      };
      townlands: {
        Row: {
          id: string;
          name: string;
          description: string;
          species: string;
          total_land_area: string;
          created_at: string;
          updated_at: string;
          created_by: string | null;
          updated_by: string | null;
        };
        Insert: {
          id?: string;
          name: string;
          description: string;
          species: string;
          total_land_area: string;
          created_at?: string;
          updated_at?: string;
          created_by?: string | null;
          updated_by?: string | null;
        };
        Update: {
          id?: string;
          name?: string;
          description?: string;
          species?: string;
          total_land_area?: string;
          created_at?: string;
          updated_at?: string;
          created_by?: string | null;
          updated_by?: string | null;
        };
      };
      attestations: {
        Row: {
          id: string;
          attestation_uid: string;
          wallet_address: string;
          attestation_type: 'identity' | 'property' | 'questionnaire' | 'agreement';
          status: 'pending' | 'verified' | 'rejected' | 'revoked';
          created_at: string;
          updated_at: string;
          created_by: string | null;
          verified_by: string | null;
          verified_at: string | null;
          notes: string | null;
        };
        Insert: {
          id?: string;
          attestation_uid: string;
          wallet_address: string;
          attestation_type: 'identity' | 'property' | 'questionnaire' | 'agreement';
          status?: 'pending' | 'verified' | 'rejected' | 'revoked';
          created_at?: string;
          updated_at?: string;
          created_by?: string | null;
          verified_by?: string | null;
          verified_at?: string | null;
          notes?: string | null;
        };
        Update: {
          id?: string;
          attestation_uid?: string;
          wallet_address?: string;
          attestation_type?: 'identity' | 'property' | 'questionnaire' | 'agreement';
          status?: 'pending' | 'verified' | 'rejected' | 'revoked';
          created_at?: string;
          updated_at?: string;
          created_by?: string | null;
          verified_by?: string | null;
          verified_at?: string | null;
          notes?: string | null;
        };
      };
      telemetry_events: {
        Row: {
          id: string;
          event_name: string;
          event_category: string;
          level: 'info' | 'warn' | 'error';
          session_id: string | null;
          actor_wallet: string | null;
          subject_wallet: string | null;
          attestation_uid: string | null;
          metadata: Record<string, unknown> | null;
          created_at: string;
        };
        Insert: {
          id?: string;
          event_name: string;
          event_category: string;
          level?: 'info' | 'warn' | 'error';
          session_id?: string | null;
          actor_wallet?: string | null;
          subject_wallet?: string | null;
          attestation_uid?: string | null;
          metadata?: Record<string, unknown> | null;
          created_at?: string;
        };
        Update: {
          id?: string;
          event_name?: string;
          event_category?: string;
          level?: 'info' | 'warn' | 'error';
          session_id?: string | null;
          actor_wallet?: string | null;
          subject_wallet?: string | null;
          attestation_uid?: string | null;
          metadata?: Record<string, unknown> | null;
          created_at?: string;
        };
      };
    };
  };
}

